import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {ModalForm} from "~/components";
import {InputField, TextAreaField} from "~/components/Forms";

const schema = Yup.object().shape({
	url: Yup.string().trim().required('Vui lòng nhập domain hoặc URL đối thủ'),
});

/**
 * Modal thêm/sửa đối thủ — ModalForm + react-hook-form (chuẩn form dự án).
 *
 * Thêm: nhập domain/URL (BE tự chuẩn hoá host, chặn trùng + SSRF + trần gói).
 * Sửa (initial có id): domain KHÔNG đổi được — chỉ sửa tên/URL đại diện/ghi chú.
 */
function CompetitorAddModal({open, submitting, initial = null, onCancel, onSubmit}) {

	const isEdit = !!initial?.id;

	const {control, handleSubmit, reset, formState: {errors}} = useForm({
		defaultValues: {url: '', name: '', note: ''},
		resolver: yupResolver(schema),
	});

	useEffect(() => {
		if (open) reset({url: initial?.url || '', name: initial?.name || '', note: initial?.note || ''});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	return (
		<ModalForm
			open={open}
			icon="fa-light fa-users-viewfinder"
			title={isEdit ? `Sửa đối thủ ${initial.domain}` : 'Thêm đối thủ'}
			subtitle={isEdit
				? 'Domain không đổi được — xoá và thêm lại nếu nhập nhầm'
				: 'Nhập domain hoặc URL trang chủ của đối thủ cạnh tranh'}
			onCancel={onCancel}
			onOk={handleSubmit(onSubmit)}
			okText={isEdit ? 'Cập nhật' : 'Thêm đối thủ'}
			loading={submitting}
		>
			<Controller control={control} name="url" render={({field}) => (
				<InputField label={isEdit ? 'URL đại diện (dùng khi chấm điểm/content gap)' : 'Domain / URL đối thủ'}
					placeholder="https://doi-thu.vn" errors={errors} {...field} />
			)} />
			<Controller control={control} name="name" render={({field}) => (
				<InputField label="Tên hiển thị (tuỳ chọn)" placeholder="VD: Đối thủ A" errors={errors} {...field} />
			)} />
			<Controller control={control} name="note" render={({field}) => (
				<TextAreaField label="Ghi chú (tuỳ chọn)" rows={3}
					placeholder="VD: đối thủ mạnh nhất mảng dịch vụ SEO" errors={errors} {...field} />
			)} />
		</ModalForm>
	);
}

export default CompetitorAddModal;
